import React, { useState } from "react";
import { getWfPhasesColor } from "../../services/appService";
import Moment from "react-moment";
import TaskHistory from "../../components/TaskHistory";
import TaskReAssignPopup from "../../components/TaskReAssignPopup";

export default function TaskInfo(props) {
    const { wfTask, app, handleReAssignSubmit, handleShowHideSection, handleWorkflowModalShowHide, workflowLabel } = props;

    const [historyAppShowHide, setHistoryAppShowHide] = useState(false);
    const [reAssignShowHide, setReAssignShowHide] = useState(false);

    const phaseClass = getWfPhasesColor(wfTask?.wfPhase);
    const isDone = Boolean(wfTask?.status || wfTask?.taskDoneStatus === 4);
    const phaseLabel = wfTask?.wfPhase === "Application" ? "Review" : wfTask?.wfPhase || "Task";
    const taskName = wfTask?.itemName || wfTask?.taskName || "Workflow Task";
    const assigneeName = String(wfTask?.performerName || "Unassigned");
    const assigneeInitial = assigneeName.trim().charAt(0).toUpperCase() || "?";
    const workflowText = workflowLabel || (app?.workflowId ? `Workflow #${app.workflowId}` : "Workflow Map");
    const taskReference = wfTask?.wiid ? `Task #${wfTask.wiid}` : app?.ciid ? `Application #${app.ciid}` : "Task";

    const handlehistoryAppModalShowHide = () => {
        if (!historyAppShowHide) setReAssignShowHide(false);
        setHistoryAppShowHide(!historyAppShowHide);
        handleShowHideSection(!historyAppShowHide);
    };

    const handleReAssignModalShowHide = () => {
        if (!reAssignShowHide) setHistoryAppShowHide(false);
        setReAssignShowHide(!reAssignShowHide);
        handleShowHideSection(!reAssignShowHide);
    };

    return (
        <React.Fragment>
            <div className={`rt-task-info-card ${phaseClass}`}>
                <div className="rt-task-info-top">
                    <div className="rt-task-info-heading">
                        <div className="rt-task-info-icon">
                            <i className="fa fa-tasks" aria-hidden="true" />
                        </div>
                        <div className="rt-task-info-title-wrap">
                            <div className="rt-task-info-kicker">
                                <span>{phaseLabel}</span>
                                <span className="rt-task-info-dot" />
                                <span>{taskReference}</span>
                            </div>
                            <h3 className="rt-task-info-title">{taskName}</h3>
                        </div>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
                        <div className="rt-task-info-action-list" style={{ display: "flex", gap: "8px" }}>
                            {wfTask?.wfPhase !== "Application" && (
                                <button
                                    type="button"
                                    className="rt-action-btn"
                                    onClick={() => handleReAssignModalShowHide(wfTask)}
                                    title="Re-assign Task"
                                >
                                    <i className="fa fa-user-plus" aria-hidden="true" />
                                    Re-Assign
                                </button>
                            )}
                            <button
                                type="button"
                                className="rt-action-btn"
                                onClick={() => handlehistoryAppModalShowHide(wfTask)}
                                title="View Task History"
                            >
                                <i className="fa fa-history" aria-hidden="true" />
                                History
                            </button>
                            {handleWorkflowModalShowHide && (
                                <button
                                    type="button"
                                    className="rt-action-btn"
                                    onClick={() => handleWorkflowModalShowHide(app)}
                                    title="View Workflow Map"
                                >
                                    <i className="fa fa-sitemap" aria-hidden="true" />
                                    {workflowText}
                                </button>
                            )}
                        </div>
                    </div>
                </div>

                <div className="rt-task-info-body" style={{ gridTemplateColumns: "1fr" }}>
                    <div className="rt-task-info-grid">
                        <div className="rt-task-info-item">
                            <span className="rt-task-info-label">
                                <i className="fa fa-calendar-plus-o" aria-hidden="true" /> Start Time
                            </span>
                            <span className="rt-task-info-val">
                                {wfTask?.startDate ? (
                                    <Moment format="MMM Do YYYY, h:mm a">
                                        {wfTask.startDate}
                                    </Moment>
                                ) : (
                                    <span className="rt-task-muted">Not set</span>
                                )}
                            </span>
                        </div>

                        <div className="rt-task-info-item">
                            <span className="rt-task-info-label">
                                <i className="fa fa-calendar-check-o" aria-hidden="true" /> End Time
                            </span>
                            <span className="rt-task-info-val">
                                {wfTask?.endDate ? (
                                    <Moment format="MMM Do YYYY, h:mm a">
                                        {wfTask.endDate}
                                    </Moment>
                                ) : (
                                    <span className="rt-task-muted">In Progress</span>
                                )}
                            </span>
                        </div>

                        <div className="rt-task-info-item">
                            <span className="rt-task-info-label">
                                <i className="fa fa-user-circle-o" aria-hidden="true" /> Assigned To
                            </span>
                            <span className="rt-task-assignee">
                                <span className="rt-task-assignee-avatar">{assigneeInitial}</span>
                                <span className="rt-task-info-val">{assigneeName}</span>
                            </span>
                        </div>

                        <div className="rt-task-info-item">
                            <span className="rt-task-info-label">
                                <i className="fa fa-tag" aria-hidden="true" /> Phase
                            </span>
                            <span className="rt-task-info-val">{phaseLabel}</span>
                        </div>

                        <div className="rt-task-info-item">
                            <span className="rt-task-info-label">
                                <i className="fa fa-info-circle" aria-hidden="true" /> Task Status
                            </span>
                            <span className="rt-task-info-val" style={{ display: "inline-flex", alignItems: "center" }}>
                                <span className={`rt-task-status-badge ${isDone ? "is-done" : phaseClass}`}>
                                    <i className={`fa ${isDone ? "fa-check" : "fa-clock-o"}`} aria-hidden="true" />
                                    {isDone ? "Done" : "In Progress"}
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            {historyAppShowHide && (
                <TaskHistory
                    historyAppShowHide={historyAppShowHide}
                    handlehistoryAppModalShowHide={handlehistoryAppModalShowHide}
                    selectedObj={wfTask}
                    doneTasks={app?.workflowTasks || []}
                    taskPhases={app?.allWfPhase || []}
                />
            )}
            {reAssignShowHide && (
                <TaskReAssignPopup
                    reAssignShowHide={reAssignShowHide}
                    handleReAssignModalShowHide={handleReAssignModalShowHide}
                    selectedObj={wfTask}
                    handleReAssignSubmit={handleReAssignSubmit}
                />
            )}
        </React.Fragment>
    );
}
